import React, { useEffect } from 'react';
import { PaymentElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { usePayment } from '../../hooks/usePayment';


interface PaymentFormProps {
  /** Receives the confirmed SetupIntent id once the card is saved. */
  onPaymentSuccess: (setupIntentId: string) => void;
  onProcessingChange: (isProcessing: boolean) => void;
  onReadyChange: (isReady: boolean) => void;
  formId: string;
  clientSecret: string;
}

export const PaymentForm: React.FC<PaymentFormProps> = ({ onPaymentSuccess, formId, onReadyChange, onProcessingChange, clientSecret}) => {
  const stripe = useStripe();
  const elements = useElements();
  const { confirmCardPayment, isProcessing } = usePayment();
  useEffect(() => {
    onProcessingChange(isProcessing);

  }, [isProcessing, onProcessingChange]);

  useEffect(() => {
    onReadyChange(!!stripe && !!elements);
  }, [stripe, elements, onReadyChange]);

  // Save the card (SetupIntent). No money is taken here.
  const processPayment = async () => {
    if (!stripe || !elements) {
      console.error("Stripe.js has not yet loaded.");
      return;
    }
    try {
      const setupIntent = await confirmCardPayment({ stripe, elements, clientSecret });
      if (setupIntent) {
        onPaymentSuccess(setupIntent.id);
      }
    } catch (error) {
      // The usePayment hook already shows a toast on error
      console.error("Saving card failed:", error);
    }
  };

  // This handler is for the main form's "submit" event (the footer button)
  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    await processPayment();
  };

  return (
    <form id={formId} onSubmit={handleSubmit}>
      <PaymentElement />
    </form>
  );
};